// ── Assessor/collector ENTITY identity key ──────────────────────────────────
// Single source of truth for "are these two rows the same real-world office?".
//
// Reduce a full official title to a comparable CORE. Existing DB names are short ("Fulton County",
// "City of Acworth"); the sheet's are full titles ("Fulton County Board of Tax Assessors", "City of
// Acworth Finance Department"). Strip OFFICE TITLES but PRESERVE identity tokens ("county", "city of",
// "town of") so a county collector never collapses onto a same-name city one. The match is STATE-SCOPED
// at the call site — always key on `${state}|${entityKey(name)}`, never on the name alone.
// Proven on GA: 159/159 assessors + 283/290 collectors matched, 0 false merges.
//
// This MUST stay shared. Both importers and the Add/Edit modals resolve an entity_id with it; if a
// hand-added assessor used a different normalization than the importer, the next import would fail to
// match it, mint a second entity_id for the same office, and split the entity's year-versions.
export const OFFICE_SUFFIXES = [
  /\bboard of tax assessors\b/, /\bboard of assessors\b/, /\bboard of assessment( appeals)?\b/,
  /\btax assessors?\b/,
  /\btax commissioners?\b/, /\brevenue commissioners?\b/,       // "county" deliberately NOT stripped
  /\btax collectors?\b/, /\btax department\b/, /\brevenue department\b/,
  /\bdepartment of finance\b/, /\bfinance department\b/,
  /\bcity clerks?\b/, /\btown clerks?\b/, /\bappraisal district\b/,
];

// Office-suffix-stripped, lowercased, punctuation-normalized core of a name.
export const entityKey = (raw) => {
  let s = String(raw == null ? '' : raw).toLowerCase()
    .replace(/[–—]/g, '-').replace(/[.,]/g, '')     // en/em dash → hyphen; drop dots/commas
    .replace(/\s*-\s*/g, ' - ').replace(/\s+/g, ' ').trim();
  for (const re of OFFICE_SUFFIXES) s = s.replace(re, '');
  return s.replace(/\s+/g, ' ').trim();
};

// State-scoped entity key — the form every caller should actually compare on.
export const stateEntityKey = (state, name) => `${state || ''}|${entityKey(name)}`;
